import getBetweenByOneDate from '../../../../../../helpers/filters/get-between-by-one-date'
import { orderRequestType } from '../../../../../../constants/entity-enums/order-request-types'
import { Filters } from '../../../../../../types/strapi/strapi'
import FormValues from '../components/filters-form/types/form-values'

const toStatusFilter = (status: string | string[]) =>
    Array.isArray(status) ? { $in: status } : { $eq: status }

export const buildFilters = (formValues: Partial<FormValues> = {}): Filters => {
    const {
        requestStatus,
        createdAt,
        materialTypeDocId,
        materialWidth,
        amount,
        initiatorDocId,
    } = formValues

    const filters: Filters = {
        goodsType: { $eq: orderRequestType[0] },
        ...(requestStatus ? { requestStatus: toStatusFilter(requestStatus) } : {}),
        ...(createdAt ? { createdAt: getBetweenByOneDate(createdAt) } : {}),
        ...(initiatorDocId ? { initiator: { documentId: { $eq: initiatorDocId } } } : {}),
    }

    const materialFilters: Record<string, unknown> = {}

    if (materialTypeDocId) {
        materialFilters.material_type = { documentId: { $eq: materialTypeDocId } }
    }

    if (materialWidth != null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            materialFilters.width = { $eq: width }
        }
    }

    if (Object.keys(materialFilters).length > 0) {
        filters.material = materialFilters
    }

    if (amount != null && amount !== '') {
        const amountNum = Number(amount)
        if (!Number.isNaN(amountNum)) {
            filters.amount = { $eq: amountNum }
        }
    }

    return filters
}
